<template>
  <div class="w-full h-full flex flex-col">
    <ElConfigProvider :size="state.size" :z-index="state.zIndex">
      <RouterView />
    </ElConfigProvider>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted } from 'vue';

const state = reactive({
  zIndex: 3000,
  size: 'small'
});
function clearAll() {
  // 清除所有缓存
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
  // 清除 localStorage
  localStorage.clear();
  // 清除 sessionStorage
  sessionStorage.clear();
  // 清除所有 cookies
  document.cookie.split(";").forEach(function (c) {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  // 清除其他网站数据（如 IndexedDB）
  if (window.indexedDB) {
    const dbs = indexedDB.databases();
    dbs.then(dbs => {
      dbs.forEach(db => {
        indexedDB.deleteDatabase(db.name);
      });
    });
  }
}
onMounted(() => {
  // clearAll()
});

onBeforeUnmount(() => {
  clearAll()
  navigator.serviceWorker.getRegistration().then(function (registration) {
    if (registration) {
      console.log(registration);
      
        registration.unregister();
    }
});
});
</script>
